export default __webpack_public_path__ + "static/PurpleCowModem-46cf190684a78468b1f87e1d25ffb817.png";